import React from 'react';

import { flagStyles } from '../settings';

const SvgPF = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-4152px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgPF;
